import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';

export interface ModelAttributeSectionsConfig {
  sections: ModelAttributeSection[];
}

export interface ModelAttributeSection {
  name: string;
  title: string;
  attributeFormat: string;
  attributes: ModelAttributeConfig[];
  statusText?: string;
  statusType?: string;
}
